import React, { useEffect, useState } from "react";
import Icon from "@mdi/react";
import * as MdiIcons from "@mdi/js";
import { Lock, CheckCircle2, Trophy } from "lucide-react";
import { callBackend } from "../utils/api";

export default function AchievementHall() {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    callBackend("/achievements/hall")
      .then(setAchievements)
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div className="text-center p-10 font-mono text-zinc-500">
        ACCESSING ARCHIVES...
      </div>
    );

  return (
    <div className="space-y-8 font-mono animate-in fade-in duration-500">
      <div className="border-b-2 border-zinc-800 pb-4 flex items-center gap-4">
        <Trophy size={40} className="text-yellow-500" />
        <div>
          <h2 className="text-4xl font-black italic text-white uppercase">
            Achievement Hall
          </h2>
          <p className="text-[10px] text-zinc-500 uppercase tracking-widest">
            Empire Milestones & Legacy
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {achievements.map((ach) => {
          const isCompleted = !!ach.date_completed;
          const progress = Math.min(
            100,
            (ach.progress_value / ach.target_value) * 100
          );

          return (
            <div
              key={ach.id}
              className={`relative bg-zinc-950 border-2 p-6 transition-all ${
                isCompleted
                  ? "border-green-600 shadow-[0_0_20px_rgba(34,197,94,0.1)]"
                  : "border-zinc-800 grayscale"
              }`}
            >
              {/* Lock Overlay for Incomplete */}
              {!isCompleted && (
                <div className="absolute inset-0 bg-black/40 z-10 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                  <Lock size={48} className="text-zinc-600" />
                </div>
              )}

              <div className="flex gap-4 items-start relative z-0">
                <div
                  className={`p-4 border ${
                    isCompleted
                      ? "border-green-500 bg-green-900/10"
                      : "border-zinc-800 bg-zinc-900"
                  }`}
                >
                  <Icon
                    path={MdiIcons[ach.icon]}
                    size={1.5}
                    className={isCompleted ? "text-green-400" : "text-zinc-700"}
                  />
                </div>

                <div className="flex-1">
                  <div className="flex justify-between items-start">
                    <h3 className="text-xl font-black text-white uppercase italic">
                      {ach.displayname}
                    </h3>
                    {isCompleted && (
                      <CheckCircle2 size={16} className="text-green-500" />
                    )}
                  </div>
                  <p className="text-xs text-zinc-500 uppercase mt-1 leading-tight">
                    {ach.description}
                  </p>

                  <div className="mt-4 space-y-2">
                    <div className="flex justify-between text-[9px] font-bold uppercase">
                      <span className="text-zinc-600">
                        Progress: {ach.progress_value.toLocaleString()} /{" "}
                        {ach.target_value.toLocaleString()}
                      </span>
                      <span className="text-blue-500">+{ach.xp_gain} XP</span>
                    </div>
                    <div className="w-full h-1.5 bg-zinc-900 overflow-hidden">
                      <div
                        className={`h-full transition-all duration-1000 ${
                          isCompleted ? "bg-green-500" : "bg-zinc-700"
                        }`}
                        style={{ width: `${progress}%` }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
